module.exports = __webpack_public_path__ + "img/config-icon.c0639754.svg";